module.exports = __webpack_public_path__ + "static/media/cartao-de-credito-carrefour.5e26637e.png";